import React from 'react';
import './home.css'

export default function  Footer(){
    return <>
   
    <div id='Footer'>
    <ul className='homeFlex2' type="none">
        <div>
      <li className='footerHeading'>Ajio</li>
      <li >Who We Are</li>
      <li>Join Our Team</li>
      <li>Terms & Conditions</li>
      <li>We Respect Your Privacy</li>
      <li>Fees & Payment</li>
      <li>Returns & Refund Policy</li>
      </div>
      <div>
      <li className='footerHeading'>Help</li>
      <li>Track Your Order</li>
      <li>Frequently Asked Question</li>
      <li>Returns</li>
      <li>Cancellations</li>
      <li>Payments</li>
      <li>Customer Care</li>
      </div>
      <div>
      <li className='footerHeading'>Shop by</li>
      <li>Men</li>
      <li>Women</li>
      <li>Indie</li>
      <li>Stores</li>
      <li>New Arrivals</li>
      <li>Brand Directory</li>
      </div>
      <div>
      <li className='footerHeading'>Follow us</li>
      <li>Facebook</li>
      <li>Instagram-AJIOlife</li>
      <li>Instagram-AJIO LUXE</li>
      <li>Twitter</li>
      <li>Pinterest</li>
      </div>
    </ul>
    <hr className='footerLine' />

    <div className='footerPayment'>
      <div>
       <h3 className='footerPaymentHeading1'>AJIO</h3>
      </div>
      <div>
       <h5 className='footerPaymentHeading2'>© 2023 AJIO, Inc.</h5>
      </div>
    </div>

    </div>


    </>
}